'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplTokenMetadata = require('@metaplex-foundation/mpl-token-metadata');
var web3_js = require('@solana/web3.js');
var Operation = require('../../../types/Operation.cjs');
var TransactionBuilder = require('../../../utils/TransactionBuilder.cjs');

// -----------------
// Operation
// -----------------

const Key = 'VerifyNftCreatorOperation';

/**
 * Verifies the creator of an NFT or SFT.
 *
 * ```ts
 * await metaplex
 *   .nfts()
 *   .verifyCreator({ mintAddress, creator };
 * ```
 *
 * @group Operations
 * @category Constructors
 */
const verifyNftCreatorOperation = Operation.useOperation(Key);

/**
 * @group Operations
 * @category Types
 */

/**
 * @group Operations
 * @category Handlers
 */
const verifyNftCreatorOperationHandler = {
  handle: async (operation, metaplex, scope) => {
    return verifyNftCreatorBuilder(metaplex, operation.input, scope).sendAndConfirm(metaplex, scope.confirmOptions);
  }
};

// -----------------
// Builder
// -----------------

/**
 * @group Transaction Builders
 * @category Inputs
 */

/**
 * Verifies the creator of an NFT or SFT.
 *
 * ```ts
 * const transactionBuilder = metaplex
 *   .nfts()
 *   .builders()
 *   .verifyCreator({ mintAddress, creator });
 * ```
 *
 * @group Transaction Builders
 * @category Constructors
 */
const verifyNftCreatorBuilder = (metaplex, params, options = {}) => {
  const {
    programs,
    payer = metaplex.rpc().getDefaultFeePayer()
  } = options;
  const {
    mintAddress,
    creator = metaplex.identity()
  } = params;

  // Programs.
  const systemProgram = metaplex.programs().getSystem(programs);
  const tokenMetadataProgram = metaplex.programs().getTokenMetadata(programs);
  return TransactionBuilder.TransactionBuilder.make().setFeePayer(payer)

  // Verify the creator.
  .add({
    instruction: mplTokenMetadata.createVerifyInstruction({
      authority: creator.publicKey,
      metadata: metaplex.nfts().pdas().metadata({
        mint: mintAddress,
        programs
      }),
      systemProgram: systemProgram.address,
      sysvarInstructions: web3_js.SYSVAR_INSTRUCTIONS_PUBKEY
    }, {
      verificationArgs: mplTokenMetadata.VerificationArgs.CreatorV1
    }, tokenMetadataProgram.address),
    signers: [creator],
    key: params.instructionKey ?? 'verifyCreator'
  });
};

exports.verifyNftCreatorBuilder = verifyNftCreatorBuilder;
exports.verifyNftCreatorOperation = verifyNftCreatorOperation;
exports.verifyNftCreatorOperationHandler = verifyNftCreatorOperationHandler;
//# sourceMappingURL=verifyNftCreator.cjs.map
